{
  "id": "campaign-127",
  "name": "Golden Arena",
  "seed": "campaign:127",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "r....QQQQ....r",
    "~.:#.......:..",
    ".~:..a..a..:..",
    "..::::::::::..",
    ".#.......,,,..",
    "........,,,...",
    ".a.a.a..a.a.a.",
    "..............",
    "::::::::::::::",
    "..a..a..a..a..",
    "..........x.,.",
    "....x......,,,",
    "..::::::::::,.",
    ".a:.a....a.:a.",
    "..:........:..",
    "S....QQQQ....."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 12,
      "y": 1
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 3
    },
    {
      "kind": "rabbit",
      "x": 8,
      "y": 7
    },
    {
      "kind": "squirrel",
      "x": 9,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 8
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 12,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 15
    },
    {
      "kind": "repair",
      "x": 9,
      "y": 8
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "balls": {
    "first": 18,
    "every": 15
  },
  "generatorVersion": 3,
  "level": 127,
  "biome": "stadium",
  "par": {
    "reel": 7558,
    "push": 6473,
    "selfPropelled": 6006,
    "tractor": 4875,
    "zeroTurn": 4237,
    "fairway": 2941
  },
  "goldTime": {
    "reel": 7453,
    "push": 6356,
    "selfPropelled": 5982,
    "tractor": 4875,
    "zeroTurn": 4195,
    "fairway": 2693
  },
  "routeTries": {
    "par": {
      "reel": 9,
      "push": 4,
      "selfPropelled": 15,
      "tractor": 9,
      "zeroTurn": 19,
      "fairway": 16
    },
    "gold": {
      "reel": 25,
      "push": 39,
      "selfPropelled": 40,
      "tractor": 9,
      "zeroTurn": 25,
      "fairway": 46
    }
  }
}
